<template>
  <div id="PriceFunFood">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="datepickerwrap row card">
      <div class="col-10" style="display: flex">
        <div class="customSelect">
          <datepicker
            :disabled="timestamp1Disabled"
            @input="refresh"
            v-model="timestamp"
          />
        </div>
        <div class="customSelect">
          <datepicker
            :disabled="timestamp2Disabled"
            @input="refresh"
            v-model="timestamp2"
          />
        </div>
        <div class="customSelect">
          <select
            @change="getPriceData"
            v-model="selectedCat"
            class="form-control text-uppercase"
          >
            <option v-for="d in catOptions" :value="d" :key="d">
              {{ d.replace("_", " ") }}
            </option>
          </select>
        </div>
        <div class="customSelect">
          <select
            @change="getPriceData"
            v-model="selectedPlatform"
            class="form-control text-uppercase"
          >
            <option value="">All</option>
            <option v-for="(d, i) in platformColor" :value="i" :key="i">{{ i }}</option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <input
          class="form-control"
          type="text"
          @keyup="searchProduct"
          v-model="schKey"
          placeholder="Search"
        />
      </div>
    </div>
    <div class="container-fluid">
      <div class="">
        <b-row v-for="(od, oi) in data" :key="'product_price_' + oi">
          <b-col sm="12" lg="12">
            <b-row class="">
              <div
                class="col-6 pr-xl-0"
                v-for="(pd, pi) in od"
                :key="'compTimelines_' + oi + '_' + pd.product_name + '_' + pi"
              >
                <div class="card">
                  <h5 :title="pd.product_name" class="graphHeading">
                    {{ pd.product_name.toUpperCase() }}
                  </h5>
                  <div style="">
                    <div
                      style="width: 100% !important"
                      :class="{ chartOverflow: od.length > 1 }"
                    >
                      <highcharts
                        :style="getChartWidth(od.length)"
                        :options="
                          chartData['compChart_' + oi + '_' + pd.product_name + '_' + pi]
                        "
                      ></highcharts>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row
              v-for="(pd, pi) in od"
              class="card ml-1"
              :key="'compSummary_' + oi + '_' + pd.product_name + '_' + pi"
            >
              <div class="col-sm-12">
                <h5 class="graphHeading" style="margin-bottom: 0px">
                  {{ pd.product_name.toUpperCase() }}
                </h5>
              </div>
              <div class="borderBetween"></div>
              <b-row>
                <b-col
                  :class="{ 'col-sm-2': selectedPlatform }"
                  style=""
                  v-for="d in pd.platform_data"
                  :key="d.platform + oi"
                >
                  <div style="border: none" :class="d.platform + '_border'">
                    <div class="rightsticker">
                      <div class="name">
                        <img style="width: 19px" :src="'/img/' + d.platform + '.png'" />
                        <a v-if="d.link" target="_blank" :href="d.link">
                          {{ d.platform }}
                        </a>
                        <span v-else> {{ d.platform }} </span>
                      </div>
                      <div class="value" :style="'color:' + platformColor[d.platform]">
                        <i
                          class="fa fa-rupee"
                          v-if="
                            (d.discount_price && d.discount_price != 'N/A' && d.link) ||
                            (d.original_price && d.original_price != 'N/A')
                          "
                        ></i>
                        <span v-if="d.discount_price">
                          {{ formatNumber(d.discount_price) }}</span
                        >
                        <span v-if="!d.discount_price && d.original_price">
                          {{ formatNumber(d.original_price) }}</span
                        >
                        <span v-if="d.quantity"> ({{ d.quantity }})</span>
                        <div class="outofstock" v-if="d.not_available">Not Available</div>
                        <div class="outofstock" v-if="!d.not_available && d.out_of_stock">
                          Out of stock
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "PriceFunFood",
  components: {
    Datepicker,
  },
  data: function () {
    return {
      data: {},
      moment: moment,
      seriesDataFiltered: [],
      timestamp: moment().subtract(7, "days").format("YYYY-MM-DD"),
      timestamp2: moment().subtract(1, "day").format("YYYY-MM-DD"),
      // timestamp2: moment().add(1,'days').format('YYYY-MM-DD'),
      timestamp1Disabled: {
        to: "",
        from: "",
      },
      timestamp2Disabled: {
        to: "",
        from: "",
      },
      catOptions: [],
      loader: false,
      selectedCat: "",
      schKey: "",
      dataFull: {},
      chartData: [],
      selectedPlatform: "",
      platformColor: {
        amazon: "#2874f0",
        flipkart: "#FF9900",
      },
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    updateDisabledDates() {
      this.timestamp1Disabled = {
        to: moment("2022-09-10", "YYYY-MM-DD").toDate(),
        from: moment(this.timestamp2, "YYYY-MM-DD").toDate(),
      };
      this.timestamp2Disabled = {
        to: moment(this.timestamp, "YYYY-MM-DD").toDate(),
        from: moment().subtract(1, "day").toDate(),
      };
    },
    getChartWidth(compCount) {
      if (compCount == 1) return "width:100%";
      let diff = moment(this.timestamp2).diff(moment(this.timestamp), "days");
      if (diff < 4) return "width:100%";
      let width = diff * 100;
      return "width:" + width + "px";
    },
    formatNumber(n) {
      if (n && !isNaN(n)) {
        return Number(n).toLocaleString();
      } else {
        return n;
      }
    },
    searchProduct() {
      let self = this;
      this.loader = true;

      setTimeout(function () {
        self.data = {};
        for (let [idx, ds] of Object.entries(self.dataFull)) {
          if (idx.toLowerCase().includes(self.schKey.toLowerCase())) {
            self.data[idx] = ds;
          }
        }
        self.loader = false;
      }, 0);
    },
    processChart() {
      let self = this;
      for (let [idx, ds] of Object.entries(this.data)) {
        for (let [idx2, ds2] of ds.entries()) {
          let chartKey = "compChart_" + idx + "_" + ds2.product_name + "_" + idx2;
          self.createChart(ds2.timeline, chartKey);
        }
      }
    },
    removeEmptySeries() {
      let self = this;
      for (let [i, d] of self.seriesDataFiltered.entries()) {
        var hasData = false;
        for (let [idx, ds] of d.data.entries()) {
          if (ds.toString().length) {
            hasData = true;
          }
        }
        if (!hasData) {
          self.seriesDataFiltered.splice(i, 1);
          this.removeEmptySeries();
        }
        if (i == self.seriesDataFiltered.length - 1) return;
      }
    },
    createChart(timeline, key) {
      let self = this;
      let xaxis = [];
      self.seriesDataFiltered = [];
      let seriesData = [];
      for (let [idx, ds] of timeline.entries()) {
        xaxis.push(moment(ds.date).format("DD MMM YYYY"));
        for (let [idx2, ds2] of ds.price.entries()) {
          if (idx == 0) {
            seriesData.push({
              name: ds2.name.toUpperCase(),
              data: [ds2.value],
              color: self.platformColor[ds2.name],
            });
          } else {
            for (let [idx3, ds3] of seriesData.entries())
              if (ds3.name == ds2.name.toUpperCase()) ds3.data.push(ds2.value);
          }
        }
      }
      if (self.selectedPlatform) {
        for (let [idx2, ds2] of seriesData.entries()) {
          if (self.selectedPlatform.toUpperCase() == ds2.name) {
            self.seriesDataFiltered.push(ds2);
          }
        }
      } else {
        self.seriesDataFiltered = seriesData;
      }
      this.removeEmptySeries();
      let obj = {};
      self.chartData[key] = {
        chart: {
          type: "line",
          height: 180,
          marginBottom: 50,
          marginTop: 20,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "bottom",
          text: "",
        },
        xAxis: {
          tickmarkPlacement: "on",
          categories: xaxis,
          title: { text: "" },
          gridLineWidth: 1,
          labels: {
            rotation: 0,
            style: { fontSize: 10, textOverflow: "none" },
          },
        },
        plotOptions: {
          line: {
            marker: {
              radius: 3,
            },
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },
              formatter: function () {
                return "₹" + this.point.y.toLocaleString();
              },
            },
          },
        },
        yAxis: {
          title: {
            text: "Price(₹)",
            margin: 25,
            style: {
              color: "#065559",
            },
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip += '<span style="color:' + this.points[i].color + '">● </span>';
              mytooltip += this.points[i].series.name;
              mytooltip += ":<b> ₹" + self.formatNumber(this.points[i].y) + "</b><br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "left",
          itemDistance: 12,
          marginTop: 10,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
          itemStyle: {
            fontSize: "10px",
          },
        },
        credits: {
          enabled: false,
        },
        series: self.seriesDataFiltered,
      };
    },
    getPriceData() {
      let self = this;
      let url = "/api/india_clients/product_price";
      this.loader = true;
      this.data = {};
      this.dataFull = {};
      let payload = {
        start_date: moment(this.timestamp).format("YYYY-MM-DD"),
        end_date: moment(this.timestamp2).format("YYYY-MM-DD"),
        item_category: this.selectedCat,
        client: "hindware",
      };
      this.$http.post(url, payload).then((response) => {
        this.loader = false;
        for (let [idx, ds] of Object.entries(response.data.data)) {
          for (let [idx2, ds2] of ds.entries()) {
            for (let [i, d] of ds2.platform_data.entries()) {
              if (d.platform == self.selectedPlatform) {
                ds2.platform_data = [d];
              }
            }
          }
          this.data[idx] = ds;
          this.dataFull[idx] = ds;
          this.processChart();
        }
        (err) => {
          this.loader = false;
        };
      });
    },
    getCat() {
      let url = "/api/india_clients/product_price_categories";
      this.loader = true;
      let payload = {
        start_date: moment(this.timestamp).format("YYYY-MM-DD"),
        end_date: moment(this.timestamp).format("YYYY-MM-DD"),
        client: "hindware",
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.loader = false;
          this.catOptions = response.data.data;
          this.selectedCat = this.catOptions[0];
          this.getPriceData();
        },
        (err) => {
          this.loader = false;
        }
      );
    },
    refresh() {
      this.updateDisabledDates();
      this.getCat();
    },
  },
};
</script>
<style scoped>
.chartOverflow {
  overflow-x: scroll;
}

.name {
  line-height: 28px;
  text-transform: capitalize;
  font-size: 14px;
  margin-left: 5px;
}

.value {
  font-size: 14px;
  line-height: 24px;
  margin-left: 5px;
}

.leftsticker {
  width: 65px;
  float: left;
  height: 54px;
  color: white;
  font-size: 37px;
  text-align: center;
}

.rightsticker {
  width: 100%;
  /* float: left; */
  background: white;
}

.card {
  margin-bottom: 8px;
}

.card-body {
  padding: 0 !important;
  display: flex;
}

.productwrap {
  padding: 26px;
  padding-top: 6px;
  margin-top: 6px;
}

.grofers_border {
  border-right: 2px solid #f15c2c !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.bigbasket_border {
  border-right: 2px solid #83c42a !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.amazon_border {
  border-right: 2px solid #ff9900 !important;
}

.croma_border {
  border-right: 2px solid #49a7a1 !important;
}

.paytm_border {
  border-right: 2px solid #28bbf0 !important;
}

.snapdeal_border {
  border-right: 2px solid #f34741 !important;
}

.myntra_border {
  border-right: 2px solid #ec548b !important;
}

.vijaysales_border {
  border-right: 2px solid #ee4326 !important;
}

.ril_border {
  border-right: 2px solid #bfa161 !important;
}

.outofstock {
  color: red;
  float: right;
  font-size: 12px;
  margin-right: 5px;
}

.flipkart_border {
  border-right: 2px solid #2874f0 !important;
}
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}
.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}
#sovindia4page {
  font-family: "Poppins", sans-serif !important;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}
.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}
.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}
.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}
.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 10px 0px !important;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}
.navigationButton:hover {
  background: var(--accent_color-80);
}
.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}
.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  font-size: 16px !important;
}
.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}
.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}
.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}
.searchIcon {
  /* height: 40px; */
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";

  background-color: var(--primary_brand);
}
.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%)
    contrast(104%);
}
.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}
.productListCheckbox span {
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}
.eachProduct:hover {
  background: var(--base_color-20);
}
</style>
